import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-top-navigation-bar js-top-navigation-bar"
}
const _hoisted_2 = { class: "_ml-a" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_share_action = _resolveComponent("share-action")

  return ($options.isPWA)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.isBackButtonVisible)
          ? (_openBlock(), _createBlock(_component_base_icon, {
              key: 0,
              class: "_pa-2",
              tag: "button",
              size: "lg",
              name: "chevron-left",
              onClick: $options.goBack
            }, null, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            ($props.projectId)
              ? (_openBlock(), _createBlock(_component_share_action, _normalizeProps(_mergeProps({ key: 0 }, $options.sharePayload)), {
                  default: _withCtx(({ onShare }) => [
                    _createVNode(_component_base_icon, {
                      tag: "button",
                      class: "_pa-2",
                      name: $options.shareIcon,
                      size: "lg",
                      onClick: onShare
                    }, null, 8 /* PROPS */, ["name", "onClick"])
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}